var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartTraveller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 3 10 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6036 5.3018C10.6036 2.3737 8.2299 0 5.3018 0C2.3737 0 0 2.3737 0 5.3018V29.6982C0 32.6263 2.3737 35 5.3018 35C8.2299 35 10.6036 32.6263 10.6036 29.6982V5.3018Z",
    fill: "#FAFCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1036 5.3018C10.1036 2.64984 7.95376 0.5 5.3018 0.5C2.64984 0.5 0.5 2.64984 0.5 5.3018V29.6982C0.5 32.3502 2.64984 34.5 5.3018 34.5C7.95376 34.5 10.1036 32.3502 10.1036 29.6982V5.3018Z",
    stroke: "#E9E9E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94434 13V21",
    stroke: "#787E8C",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83643 13V21",
    stroke: "#787E8C",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartTraveller);
export default __webpack_public_path__ + "static/media/chart-traveller.c9115e52c4c7e367f50ac9fb021f5e16.svg";
export { ForwardRef as ReactComponent };